module.exports = __webpack_public_path__ + "img/publipostage-europe-energie.b3a4bb5a.svg";